import React from 'react'

export const Banner = () => {
  return (
    <>
     <section className="main coffeemain">
    <div className="container coffeeBannerAboutus my-4">
        <div className="row">
            <div className="col-md-12 coffeeBennercol">
            <h1>CONTACT US </h1>
            </div>
        </div>
    </div>
    </section>
    </>
  )
}
